Ext.define('SA.data.UserLocationList', {
    extend: 'SA.data.UserItemList',

    constructor() {
        this.callParent(arguments);

        SA.data.LocationAliases.on('change', this.onLocationChange, this);
        SA.data.CustomLocations.on('update:locationItem', this.onLocationChange, this);
    },

    add(locations) {
        var locations = Ext.Array.from(locations).map(location => SA.data.LocationsCache.toLocationSeries(location));

        this.callParent([locations]);
    },

    ensureCached() {
        return SA.data.LocationsCache.getPromise(this.getIds());
    },

    getId(locationSeries) {
        return SA.data.LocationsCache.toLocationItem(locationSeries);
    },

    idsEqual(id1, id2) {
        return id1.id === id2.id && id1.type === id2.type;
    },

    onLocationChange(seriesOrLocation) {
        var series = SA.data.LocationsCache.toLocationSeries(seriesOrLocation);

        if (this.contains(series)) {
            this.fireEvent('change');
        }
    }
});

SA.data.FavoriteLocations = new SA.data.UserLocationList({
    resource: 'user/favoriteLocationItems'
});

SA.data.RecentLocations = new SA.data.UserLocationList({
    limit: 1000,
    resource: 'user/recentLocationItems',

    addClicked(ids) {
        this.clicked = true;

        this.add(ids);

        this.clicked = false;
    },

    isClicked(id) {
        var index = this.indexOf(id);

        if (index !== -1) {
            return this.all[index].clicked;
        }

    },

    toData(id) {
        var isClicked = this.isClicked(id),
            clicked = this.clicked === true && isClicked !== false;

        return {id, clicked};
    }
});